// App.js
import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import About from './Components/About';
import Services from './Components/services';
import Skills from './Components/Skill';
import Portfolio from './Components/Portfolio';
import Terminal from './Components/Terminal';
import ContactSection from './Components/ContactForm';
import Footer from './Components/Footer';
import BackToTop from './Components/BackToTop';
import GlobalCursor from './Components/Global_Cursor';
import ScrollProgressBar from './Components/SrollBar';
import MultilingualLoader from './Components/Loader';

import './App.css';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <AnimatePresence>
        {isLoading && (
          <MultilingualLoader key="loader" onComplete={() => setIsLoading(false)} />
        )}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoading ? 0 : 1 }}
        transition={{ duration: 0.6 }}
        className="min-h-screen bg-ink-950 text-white overflow-x-hidden"
      >
        <GlobalCursor />
        <ScrollProgressBar />
        <Navbar />
        <main>
          <Hero />
          <About />
          <Skills />
          <Portfolio />
          <Terminal />
          <Services />
          <ContactSection />
        </main>
        <Footer />
        <BackToTop />
      </motion.div>
    </>
  );
};

export default App;
